import * as styles from "./FrequentQuestion.module.scss";

import React, { type HTMLAttributes, useState } from "react";
import clip from "text-clipper";
import { Chevron } from "../common/Icons";

const ANSWER_MAX_CHARACTER_COUNT = 120;
export interface FrequentQuestionProps extends HTMLAttributes<HTMLElement> {
	question: string;
	answer: string;
	isRTE?: boolean;
	isFirst: boolean;
	jumpLinksQuestionTitle?: string;
}

export const FrequentQuestion: React.FC<FrequentQuestionProps> = ({
	question,
	answer,
	isRTE,
	jumpLinksQuestionTitle,
}) => {
	const getShortText = () => {
		if (answer.length > ANSWER_MAX_CHARACTER_COUNT)
			return `${clip(answer, ANSWER_MAX_CHARACTER_COUNT, {
				html: isRTE,
			})}`;
		return answer;
	};
	const canShowMore = answer.length > ANSWER_MAX_CHARACTER_COUNT;
	const [showAllText, setShowAllText] = useState(false);

	return (
		<div
			className={
				canShowMore ? styles.frequentquestion : styles.frequentquestionnospace
			}
		>
			{jumpLinksQuestionTitle ? (
				<h3
					className={styles.questionheading}
					data-jumplinkstitle={jumpLinksQuestionTitle}
				>
					{question}
				</h3>
			) : (
				<h3 className={styles.questionheading}>{question}</h3>
			)}
			{isRTE ? (
				<>
					{!showAllText && (
						<div
							aria-hidden={showAllText}
							className={styles.answertext}
							// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
							dangerouslySetInnerHTML={{
								__html: getShortText(),
							}}
						/>
					)}

					{answer.length > ANSWER_MAX_CHARACTER_COUNT && (
						<div
							aria-hidden={!showAllText}
							className={
								showAllText ? styles.answertext : styles.visibilityhidden
							}
							// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
							dangerouslySetInnerHTML={{
								__html: answer,
							}}
						/>
					)}
				</>
			) : (
				<p>{answer}</p>
			)}
			{canShowMore && (
				<button
					type="button"
					className={styles.showmore}
					onClick={() => setShowAllText((prevShowAll) => !prevShowAll)}
					tabIndex={0}
					onKeyDown={(e) =>
						e.key === "Enter" && setShowAllText((prevShowAll) => !prevShowAll)
					}
				>
					<Chevron
						fill="#222"
						height={"20px"}
						width={"20px"}
						rotation={showAllText ? 0 : 180}
					/>
				</button>
			)}
		</div>
	);
};

export default FrequentQuestion;
